import APIClient from '../../../common/APIClient';
import { displayError } from '../commonActions';

const FETCH_BANDS = 'FETCH_BANDS';

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchBands = () => {
  return (dispatch) => {
    client().get(
      'band/list'
    ).then(json => {
      const result = json.data;
      if (result) {
        let bands = result.data;
        if (!bands.length) {
          bands = null;
        }
        dispatch({type: FETCH_BANDS, bands});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}